import React from "react";
import { Link } from "react-router-dom";
import { Urls, Paths } from "../constants/UrlConstants";
import layoutStyle from "../assets/css/modules/shared/layout.css";

const outpatientBenefitMessage =
  "This is cover that applies when you're an out-patient.";

export default {
  AccidentalDeath:
    "Cash benefit if a member dies within 90 days of having an accident and the accident is the sole and independent cause of death.",
  AmbulanceTransport:
    "If you are having private in-patient or day-patient treatment and it is medically necessary to use a road ambulance to transport you to another medical facility.",
  CancerTreatment: {
    HOL:
      "We will cover treatment to kill cancer cells. We will cover treatment for any new cancer that starts after you join. We will also cover that cancer if it comes back and you are still a member. If you have exclusions to do with cancer because of your past medical history, we will not cover your treatment if this cancer comes back.",
    Any:
      "We will cover investigations into cancer and treatment to kill cancer cells. We will cover treatment for any new cancer that starts after you join. We will also cover that cancer if it comes back and you are still a member. If you have exclusions to do with cancer because of your past medical history, we will not cover your treatment if this cancer comes back."
  },
  CashBackDental:
    "Cash back towards the cost of fees from your Dentist. If you have an excess, you do not have to pay the excess if you claim for dentist fees.",
  CashBackOptician:
    "Cash back towards the cost of fees from your Optician. We will pay this so long as the glasses or lenses are used to correct your vision. If you have an excess, you do not have to pay the excess if you claim for optician fees.",
  CashBackEyeTest:
    "If you have an excess, you do not have to pay the excess if you claim for an eye test.",
  CashBackPlusDental: "Cash back towards the costs of Dentists fees. ",
  CashBackPlusAccident:
    "Cash back towards the cost of dental treatment needed as a result of a dental accident.",
  CashBackPlusPresctriptionContact:
    "Cash back towards the cost of prescribed glasses or contact lenses.",
  CashBackPlusEyeTest: "Cash back towards the cost of an eye test.",
  ChiropodyTreatment:
    "Chiropody and podiatry fees are covered as long as your chiropodist or podiatrist is qualified. If you have an excess, you do not have to pay the excess for this treatment. Claiming for chiropodist or podiatrist fees will not affect your no claims discount.",
  DentalTreatment: {
    Any:
      "If you have an excess, you do not have to pay the excess if you claim for dentist fees.",
    HOL:
      "If you have an excess, you do not have to pay the excess if you claim for dentist fees. Claiming for dental fees will not affect your no claims discount."
  },
  DoctorHand: (
    <React.Fragment>
      Access to a GP service for online, video or telephone consultation. You
      will need to pay for your consultation and claim the costs back from us.{" "}
      <a
        className={"hol-link " + layoutStyle.anchorDecorationUnderline}
        href={Urls.AxaDoctorAtHand}
        rel="noopener noreferrer"
        target="_blank"
      >
        Access AXA Doctor at Hand
      </a>
      .
    </React.Fragment>
  ),
  EnhancedOPSpecialistConsultations:
    "Out-patient consultations with a specialist.",
  ExtraCoverOutOfDirectory:
    "Extra cover for treatment at any UK hospital, day-patient unit or  scanning centre.",
  ExtraCoverLimitedFee:
    "Extra cover for treatment with a fee-limited specialist.",
  ExtraCoverOutsideUK:
    "Extra cover for planned treatment abroad up to the costs we would pay for equivalent treatment in the UK.",
  ExtraCoverChronicCondition:
    "Extra cover for the routine out-patient management of angina, asthma, diabetes, epilepsy, heart valve problems, high blood pressure, glaucoma, osteoarthritis, rheumatoid arthritis, thyroid problems or ulcerative colitis.",
  ExternalProsthesis: {
    Any:
      "The costs of providing or fitting an external prothesis or appliance.",
    HOL:
      "The costs of providing or fitting any external prosthesis or appliance."
  },
  ExternalProsthetic:
    "The costs of providing or fitting any external prosthesis or appliance.",
  EyeTests: {
    Any:
      "If you have an excess, you do not have to pay the excess if you claim for an eye test.",
    HOL:
      "If you have an excess, you do not have to pay the excess if you claim for an eye test. Claiming for an eye test will not affect your no claims discount."
  },
  HealthAssessment:
    "Contribution towards the cost of a health assessment every year. The benefit is for the lead member and their partner/spouse if included on the cover. ",
  HospiceBenefit:
    "We will make a donation of £100 for every night you spend in a hospice or have hospice at home care.",
  HospitalAtHome:
    "This is for treatment provided at home or another clinically appropriate setting for the administration of intravenous chemotherapy for the treatment of cancer or intravenous antibiotics, which otherwise would require you to be admitted for in-patient or day-patient treatment.",
  HospitalTreatmentAtHome:
    "We will pay for a nurse to give you chemotherapy or antibiotics by intravenous drip at home or somewhere else that is appropriate.",
  InAndDayPatientTreatmentAndScans: {
    HOL:
      "If you have private in-patient treatment or day-patient treatment at a hospital or day-patient unit that is within our Directory of Hospitals.",
    SMEModular:
      "If you have private in-patient treatment or day-patient treatment at a hospital or day-patient unit that is in our Directory of Hospitals.",
    Any:
      "If you have private in-patient treatment or day-patient treatment at a hospital or day-patient unit that is not in our Directory of Hospitals."
  },
  InPatientDayPatientTreatment: {
    SMEModular:
      "Fees for psychiatric treatment if you have private in-patient treatment or day-patient treatment at a hospital or day-patient unit that is in our Directory of Hospitals.",
    Any:
      "Private hospital and day-patient unit fees for psychiatric treatment.",
    HOL:
      "So long as you use a hospital or day patient unit in our Directory of Hospitals. Including fees for: accommodation, diagnostic tests and drugs."
  },
  NhsCancerSupportLicensedDrugs:
    "If you have NHS Cancer Support we will not pay for the treatment of cancer. You will need to use the NHS, or pay for the costs of treatment yourself. We will pay for a licensed cancer drug which the NHS will not pay for. We will also pay for the cost of the drug to be given to you.",
  NhsCashBenefit:
    "This benefit is paid for each night you receive free treatment under the NHS and only if: (i) you are admitted for in-patient treatment before midnight (ii) the treatment you receive under the NHS would have been eligible for benefit privately under this policy.",
  NhsCashRadiotherapyChemotherapy:
    "If you have day-patient or out-patient radiotherapy or chemotherapy on the NHS, and your plan would have covered that treatment, we will make a cash payment to you.",
  OralSurgery:
    "So long as your dentist refers you, we will pay for: reinserting your own teeth after a trauma, surgical removal of impacted teeth, buried teeth and complicated buried roots, removal of cysts in the jaw (sometimes called enucleation).",
  OutOfDirectoryCashBenefit:
    "This benefit is payable if you receive private in-patient or day-patient treatment at a hospital or day-patient unit not listed in the Directory of Hospitals.",
  OutPatientCtMriOrPetScans: {
    HOL:
      "If you have a CT, MRI or PET scan at a facility that is within our Directory of Hospitals.",
    SMEModular:
      "If you have a CT, MRI or PET scan at a scanning centre that is in our Directory of Hospitals.",
    Any:
      "If you have a CT, MRI or PET scan at a scanning centre that is not in our Directory of Hospitals."
  },
  OutOfDirectoryCtMriOrPetScans:
    "If you have a CT, MRI or PET scan at a scanning centre that is not in our Directory of Hospitals.",
  OutPatientDiagnosticTests: {
    HOL:
      "Diagnostic tests when your specialist refers you Practitioner fees when your specialist refers you. Practitioners are nurses, dieticians, orthoptists and speech therapists. For details of cover for speech therapy needed as a result of developmental delay please see the Extra support section of the Core Cover table Claiming for speech therapy will not affect your no claims discount.",
    Any:
      "Diagnostic tests performed by your specialist or when your specialist refers you."
  },
  OutPatientRadiotherapyAndChemotherapy: (
    <React.Fragment>
      Please see your{" "}
      <Link
        className={"hol-link " + layoutStyle.anchorDecorationUnderline}
        to={Paths.CoverDocuments}
      >
        handbook
      </Link>{" "}
      for a full explanation of this benefit.
    </React.Fragment>
  ),
  OutPatientSpecialistConsultations:
    "Specialist consultations for psychiatric treatment. Psychiatric treatment by psychologists and cognitive behavioural therapists.",
  OutPatientSurgicalProcedures:
    "This is an operation or other invasive surgical intervention listed in the schedule of procedures and fees - carried out in a hospital or clinic and you are not admitted as a day patient or an in-patient.",
  OutPatientSurgicalProceduresAndScans: (
    <React.Fragment>
      Please see your{" "}
      <Link
        className={"hol-link " + layoutStyle.anchorDecorationUnderline}
        to={Paths.CoverDocuments}
      >
        handbook
      </Link>{" "}
      for a full explanation of this benefit.
    </React.Fragment>
  ),
  ParentalAccommodation: {
    Any:
      "Covers the cost of one parent staying in hospital with their child. The child must be covered by your membership and having treatment covered by it."
  },
  PrescribedSpectaclesContacts: {
    Any:
      "We will pay this so long as the glasses or lenses are used to correct your vision. If you have an excess, you do not have to pay the excess if you claim for optician fees.",
    HOL:
      "We will pay this so long as the glasses or lenses are used to correct your vision. If you have an excess, you do not have to pay the excess if you claim for optician fees. Claiming for optician fees will not affect your no claims discount."
  },
  PrivateAccommodationSupport: {
    Any:
      "Covers towards the costs for one close relative or friend to stay near to the private hospital where a member is having treatment. The member must be having treatment covered by the plan and the purpose of the hotel stay must be to provide support to the member. We will not take any excess off this cash payment."
  },
  PrivateGpFees: "Fees for visits to a private GP for consultations",
  RadiotherapyChemotherapy:
    "Private hospitals, day-patient units or scanning centres listed in our Directory of Hospitals. Radiotherapy including when it is used to relieve pain. Chemotherapy by intravenous drip at home.",
  RecuperativeCare:
    "Cover towards the cost of a nurse for secondary nursing care or a care assistant to help with household duties and personal hygiene in the 90 days following treatment if needed.",
  SpecialistConsultations: {
    HOL:
      "We pay for consultations in the order we assess the claims, which may not be the same order that you had the consultations. So the consultations we pay for may not be the first three that you had.",
    SMEModular:
      "Out-patient consultations with a specialist. We pay for consultations in the order that we assess the claims, which may not be the same order that you had the consultations.",
    Any:
      "We pay for consultations in the order that we assess the claims, which may not be the same order that you had the consultations."
  },
  SpecialistConsultationsDiagnostic: {
    HOL:
      "Specialist consultations will cover you up to your benefit limit as shown in your policy schedule.",
    Any:
      "Practitioners are nurses, dieticians, orthoptists and speech therapists."
  },
  SpeechTherapy:
    "This is treatment relating to learning disorders, speech delay, educational problems, behavioural problems, physical development or psychological development, including assessment or grading of such problems. This includes, but is not limited to, problems such as dyslexia, dyspraxia, autistic spectrum disorder, attention deficit hyperactivity disorder (ADHD) and speech and language problems, including speech therapy needed because of another medical condition.",
  StandardOPSpecialistConsultations:
    "Out-patient consultations with a specialist. We pay for consultations in the order that we assess the claims, which may not be the same order that you had the consultations.",
  StrongerMinds:
    "Face to face, email or telephone counselling arranged through Stronger Minds for members aged 18 or over.",
  TreatmentByPractitioners: {
    SMEModular:
      "Practitioners are nurses, dieticians, orthoptists, speech therapists and audiologists.",
    Any:
      "Practitioners are nurses, dieticians, orthoptists and speech therapists."
  },
  TreatmentByTherapists: {
    SMEModular:
      "Fees for out-patient treatment by physiotherapists, acupuncturists, osteopaths or chiropractors.",
    Any: "We call physiotherapists, osteopaths and chiropractors therapists."
  },
  TreatmentForPregnancyComplications: {
    HOL: (
      <React.Fragment>
        <div>
          We will cover the additional costs for treatment of medical conditions
          that arise during pregnancy or childbirth. This is subject to your
          normal policy terms and conditions in your handbook. For example:
        </div>
        <ul>
          <br />
          <li>
            Ectopic pregnancy (pregnancy where the embryo or foetus grows
            outside the womb)
          </li>
          <li>Hydatidiform mole (abnormal cell growth in the womb)</li>
          <li>Retained placenta (afterbirth retained in the womb)</li>
          <li>Placenta praevia</li>
          <li>
            Eclampsia (a coma or seizure during pregnancy and following pre
            eclampsia)
          </li>
          <li>
            Diabetes (If you have exclusions because of your past medical
            history related to diabetes, then you will not be covered for any
            treatment for diabetes during pregnancy)
          </li>
          <li>
            Post partum haemorrhage (heavy bleeding in the hours and days
            immediately after childbirth)
          </li>
          <li>Miscarriage requiring immediate surgical treatment.</li>
        </ul>
      </React.Fragment>
    ),
    Any: (
      <React.Fragment>
        We will cover the additional costs for treatment of medical conditions
        that arise during pregnancy or childbirth. For example:
        <ul>
          <li>
            Ectopic pregnancy (pregnancy where the embryo or foetus grows
            outside the womb)
          </li>
          <li>Hydatidiform mole (abnormal cell growth in the womb)</li>
          <li>Retained placenta (afterbirth retained in the womb)</li>
          <li>Placenta praevia</li>
          <li>
            Eclampsia (a coma or seizure during pregnancy and following pre
            eclampsia)
          </li>
          <li>
            Diabetes (If you have exclusions because of your past medical
            history related to diabetes, then you will not be covered for any
            treatment for diabetes during pregnancy)
          </li>
          <li>
            Post partum haemorrhage (heavy bleeding in the hours and days
            immediately after childbirth)
          </li>
          <li>Miscarriage requiring immediate surgical treatment.</li>
        </ul>
      </React.Fragment>
    )
  },
  Vaccinations:
    "Cover towards the cost of travel vaccinations and annual influenza vaccination.",
  WigsCover: {
    Any:
      "The cost of wigs or external prostheses needed because of cancer whilst you are having treatment to kill cancer cells.",
    SMEModular:
      "Towards the cost of wigs or external prostheses needed because of cancer whilst you are having treatment to kill cancer cells."
  }
};

export const BenefitSectionTooltips = {
  CoreCover: "This section shows you the core cover your membership gives you.",
  StandardOutPatient: {
    HOL: outpatientBenefitMessage,
    Any: outpatientBenefitMessage
  },
  FullOutPatient: {
    Any: (
      <React.Fragment>
        This option gives you:
        <ul>
          <li>No yearly limit on specialist charges</li>
          <li>
            No yearly limit on diagnostic tests when referred by a specialist
          </li>
          <li>
            No yearly limit on nurse, dietician, orthoptist and speech therapist
            charges when referred by a specialist
          </li>
        </ul>
      </React.Fragment>
    ),
    HOL:
      "This option gives you no yearly maximum for specialist consultations, diagnostic tests (such as out-patient MRI, CT and PET scans) and clinical practitioner charges."
  },
  EnhancedOutpatientBenefit: outpatientBenefitMessage,
  Therapies: {
    Any:
      "Fees for out-patient treatment by physiotherapists, acupuncturists, osteopaths or chiropractors.",
    HOL:
      "This option gives you a combined limit each year up to your benefit limit shown in your policy schedule."
  },
  MentalHealth: {
    Any:
      "If you have the Mental Health option, we will pay for covered in-patient or day-patient treatment.",
    HOL:
      "If you have the Mental Health Option, we will pay for covered in-patient or day-patient psychiatric treatment, including specialist fees, as shown in the Mental Health Option table."
  },
  ExtraCareBenefit: {
    HOL: (
      <React.Fragment>
        This option gives policyholders access to extra benefits, including:
        <ul>
          <li>
            Hospital at home: a nurse to give you intravenous chemotherapy or
            antibiotics in your own home, as an alternative to having to go into
            hospital
          </li>
          <li>
            NHS cash benefit: you will receive a cash payment of £50 per night,
            up to £2000 a year when you have free treatment under the NHS and
            stay overnight, if we would’ve covered this privately
          </li>
          <li>Oral surgery: Some oral surgery treatments are paid in full</li>
          <li>Chiropody: up to £150 a year</li>
        </ul>
      </React.Fragment>
    ),
    Any: (
      <React.Fragment>
        This option gives policyholders access to extra benefits, including:
        <ul>
          <li>
            Hospital at home: a nurse to give you intravenous chemotherapy or
            antibiotics in your own home, as an alternative to having to go into
            hospital
          </li>
          <li>
            NHS cash benefit: you will receive a cash payment of £50 per night,
            up to £2000 a year when you have free treatment under the NHS and
            stay overnight, if we would’ve covered this privately
          </li>
          <li>Oral surgery: Some oral surgery treatments are paid in full</li>
          <li>Chiropody: up to £150 a year</li>
        </ul>
      </React.Fragment>
    )
  },
  DentistOpticianCashBack:
    "If you have the Dentist and Optician Cashback Option, we will pay towards dentists' and opticians' fees but not fees for services that a GP could normally carry out, or any other primary care services. We will not pay towards the cost of: contact lens check ups, contact lens solution, repairs to non-prescribed glasses, new frames, replacements that you need because of accidental damage, non-prescribed items that you buy as part of an eye care contract scheme.",
  ComprehensiveCoreCover: {
    HOL:
      "We will cover treatment for any new cancer that starts after you join. We will also cover that cancer if it comes back and you are still a member. This is subject to your normal policy terms and conditions in your handbook.",
    Any:
      "We will cover treatment for any new cancer that starts after you join. We will also cover that cancer if it comes back and you are still a member."
  },
  ExtendedCover: (
    <React.Fragment>
      This option gives you:
      <ul>
        <li>
          Treatment at any hospital, day-patient unit, or scanning centre (even
          if it’s not in our Directory of Hospitals)
        </li>
        <li>Fee-limited specialists – paid in full</li>
        <li>
          Treatment outside of the UK – covered up to what we would pay for the
          same treatment in the UK
        </li>
        <li>
          Up to five consultations a year with a AXA Doctor at Hand GP. Access to a GP
          service for online, video or phone consultations. You will need to
          register for this service, please{" "}
          <Link
            className={"hol-link " + layoutStyle.anchorDecorationUnderline}
            to={Paths.GPAppointments247}
          >
            click here
          </Link>{" "}
          to find out more. You will need to pay for your consultations and
          claim the costs back from us.
        </li>
      </ul>
    </React.Fragment>
  )
};
